export const sanitizeSidebarLinks = (value: string): string => (value || '').replace(/-|_/g, ' ');
